<template>
    <div v-cloak>
        <template v-if="loggedIn">
            <template v-if="ordersToRun.length > 0">
                <div v-for="order in ordersToRun">
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <div class="bg-white bg-white cmp-product-thumb p-3">
                                <div>
                                    <b v-html="$translate('Ceres::Template.contactOrderId')"></b>
                                    {{ order.id }}
                                </div>
                                <div>
                                    <b v-html="$translate('Ceres::Template.orderConfirmationDate')"></b>
                                    {{ order.createdAt | moment('DD.MM.YYYY') }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-9 mt-2 mt-lg-0">
                            <ul class="product-list row grid">
                                <template v-for="item in order.orderItems ">
                                    <li class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <category-item
                                                :item-data="item.data"
                                                :decimal-count="$ceres.config.item.storeSpecial"
                                                :disable-carousel-on-mobile="false">
                                        </category-item>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <hr>
                </div>
            </template>
            <template v-else>
                <div class="bg-white cmp-product-thumb p-4">
                    <div class="text-center fs-110">{{ $translate("Bigtex5::Template.meinbigtexNoItemBought") }}</div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="bg-white cmp-product-thumb p-4">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="h3 mb-4">{{ $translate("Bigtex5::Template.meinbigtexWhatIsIt") }}</div>
                        <div v-html="$translate('Bigtex5::Template.meinbigtexText')">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <hr class="d-lg-none">
                        <div class="h3 mb-4">{{ $translate("Bigtex5::Template.meinbigtexLogin") }}</div>
                        <login></login>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default
    {
        data: function()
        {
            return {
                orders:[]
            }
        },
        mounted: function()
        {
            this.$nextTick(() => {
                this.getitems();
            });
        },
        methods:
        {
            getitems:function()
            {
                let _self = this;
                $.ajax(
                    {
                        type: 'GET',
                        url: '/meinbigtexdata/',
                        success: function (data)
                        {
                            //console.log(data);
                            _self.orders = data;

                        }
                    });
            }
        },
        computed:
        {
            loggedIn:function()
            {
                if(this.$store.state.user.userData != null)
                {
                    return true;
                }
                else
                {
                    return false;
                }
            },
           ordersToRun:function()
           {
             return this.orders;
           }

        }
    }
</script>
